import React, { useContext, useEffect, useState } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import axios from 'axios'
import { toast } from 'react-toastify';
import { Editor } from '@tinymce/tinymce-react';

import authContext from '../../context/authContext/authContext';
import { useDispatch } from 'react-redux';
import { editPartnerAction } from '../../redux/actions/partnersAction';
import { isValidEmail } from '../../utils/utils';
import RenderError from '../../utils/RenderError';

const IMAGE_UPLOAD_ENDPOINT = "https://api.cloudinary.com/v1_1/dnut9ipl0/image/upload"

const intialState = { nameError: '', emailError: '', phoneError: '', partner: {}, editPartnerError: '', updateStatus: false }

const EditPartner = ({ isOpen, toggle, partnerId, partners, getPartners, loading }) => {
  const dispatch = useDispatch();
  const { getConfig } = useContext(authContext)

  const [state, setCompleteState] = useState(intialState)
  const setState = (newState) => setCompleteState((prevState) => ({ ...prevState, ...newState }));

  const onHideModal = () => {
    setState({ ...intialState });
    toggle();
  }

  useEffect(() => {
    const partner = (partners || []).find((partner) => partner?._id === partnerId);
    if (partner) {
      partner.imageUrl = partner.image;
    }
    setState({ partner: JSON.parse(JSON.stringify(partner || {})) })
  }, [partnerId]);


  const handleSubmit = (e) => {
    e.preventDefault();
    editPartner();
  }

  const editPartner = async () => {
    const { partner: { name, email, phone, status }, nameError, editPartnerError, phoneError, emailError, updateStatus } = state;
    const isValid = name && email && phone && status && (nameError === intialState.nameError) && (editPartnerError === intialState.editPartnerError) && (phoneError === intialState.phoneError) && (emailError === intialState.emailError) && (emailError === intialState.emailError);
    if (!isValid) {
      setState({ editPartnerError: '*Please fill all the required fields' });
      return;
    }

    const config = getConfig()
    const update = { ...state.partner, updateStatus }
    dispatch(editPartnerAction(update, config, getPartners, onHideModal))
  }

  const validateName = () => {
    if (!state.partner.name) {
      setState({ nameError: '*Please enter partner name' });
    }
  }

  const validatePhone = () => {
    if (!state.partner.phone) {
      setState({ phoneError: '*Please enter phone number' });
    }
  }

  const validateEmail = () => {
    if (!isValidEmail(state.partner.email)) {
      setState({ emailError: '*Please enter valid email' });
    }
  }

  const updatePartnerstate = (key, value) => {
    const { partner } = state || {};
    partner[key] = value;
    setState({ partner })
  }

  const closeBtn = () => <button className='btn btn-close' onClick={onHideModal}>X</button>;

  return (
    <Modal isOpen={isOpen} toggle={onHideModal} size='lg'>
      <ModalHeader toggle={onHideModal} close={closeBtn()}>
        <div className='d-flex align-items-center'>
          <div>Edit Partner</div>
          <div className='ml-3'>
            {loading ? <div class="spinner-border text-primary" role="status" /> : null}
          </div>
        </div>
      </ModalHeader>
      <ModalBody>
        <form onSubmit={handleSubmit}>
          <div className='row'>
            <div className='col-md-6'>
              <div className="form-group">
                <label>Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={state?.partner?.name}
                  onChange={(e) => updatePartnerstate('name', e.target.value)}
                  onBlur={validateName}
                  onFocus={() => setState({ nameError: '', editPartnerError: '' })}
                  disabled={loading}
                />
                <RenderError error={state?.nameError} />
              </div>
            </div>

            <div className='col-md-6'>
              <div className="form-group">
                <label>Email</label>
                <input
                  type="text"
                  className="form-control"
                  value={state?.partner?.email}
                  onBlur={validateEmail}
                  onFocus={() => setState({ emailError: '', editPartnerError: '' })}
                  onChange={(e) => updatePartnerstate('email', e.target.value)}
                  disabled={loading}
                />
                <RenderError error={state?.emailError} />
              </div>
            </div>

            <div className='col-md-6'>
              <div className="form-group">
                <label>Phone</label>
                <input
                  type="text"
                  className="form-control"
                  value={state?.partner?.phone}
                  onBlur={validatePhone}
                  onFocus={() => setState({ phoneError: '', editPartnerError: '' })}
                  onChange={(e) => updatePartnerstate('phone', e.target.value)}
                  disabled={loading}
                />
                <RenderError error={state?.phoneError} />
              </div>
            </div>

            <div className='col-md-6'>
              <div className="form-group">
                <label>Client ID</label>
                <input
                  type="text"
                  className="form-control"
                  value={state?.partner?.clientId}
                  onChange={(e) => updatePartnerstate('clientId', e.target.value)}
                  disabled={loading}
                />
              </div>
            </div>


            <div className='col-md-6'>
              <div className="form-group">
                <label>Aadhar card number</label>
                <input
                  type="text"
                  className="form-control"
                  value={state?.partner?.aadharNumber}
                  onChange={(e) => updatePartnerstate('aadharNumber', e.target.value)}
                  disabled={loading}
                />
              </div>
            </div>

            <div className='col-md-6'>
              <div className="form-group">
                <label>PAN card number</label>
                <input
                  type="text"
                  className="form-control"
                  value={state?.partner?.panNumber}
                  onChange={(e) => updatePartnerstate('panNumber', e.target.value)}
                  disabled={loading}
                />
              </div>
            </div>

            <div className='col-md-6'>
              <div className="form-group">
                <label>Bank account number</label>
                <input
                  type="text"
                  className="form-control"
                  value={state?.partner?.bankAccountNumber}
                  onChange={(e) => updatePartnerstate('bankAccountNumber', e.target.value)}
                  disabled={loading}
                />
              </div>
            </div>
            <div className='col-md-6'>
              <div className="form-group">
                <label>IFSC Code</label>
                <input
                  type="text"
                  className="form-control"
                  value={state?.partner?.ifscCode}
                  onChange={(e) => updatePartnerstate('ifscCode', e.target.value)}
                  disabled={loading}
                />
              </div>
            </div>

            <div className='col-md-6'>
              <div className="form-group">
                <label>Address</label>
                <textarea
                  type="text"
                  className="form-control"
                  value={state?.partner?.address}
                  onChange={(e) => updatePartnerstate('address', e.target.value)}
                  style={{ height: 'auto' }}
                  disabled={loading}
                />
              </div>
            </div>

            <div className='col-md-6'>
              <div className="form-group">
                <label>Status</label>
                <select
                  className="form-control"
                  value={state?.partner?.status}
                  onChange={(e) => {
                    updatePartnerstate('status', e.target.value);
                    setState({ updateStatus: true })
                  }}
                  disabled={loading}
                >
                  <option value="pending">Pending</option>
                  <option value="approved">Approved</option>
                  <option value="rejected">Rejected</option>
                </select>
              </div>
            </div>

          </div>
          <div className='text-center'>
            <RenderError error={state?.editPartnerError} />
          </div>
        </form>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onHideModal} disabled={loading}>
          Cancel
        </Button>
        <Button type='submit' color="gleamdesk-blue gleamdesk-orange" onClick={handleSubmit} disabled={loading}>
          Update Partner
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default EditPartner;